module.exports = "<p>\n  profile-comments works!\n</p>\n"